import { FieldLabel, Select, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { PassthroughNote } from '../shared/PassthroughNote.jsx';

export function ApiLookupInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Method</FieldLabel>
      <Segmented value={c.method || 'GET'} onChange={(v) => u({ method: v })}
        options={['GET', 'POST', 'PUT'].map(v => ({ value: v, label: v }))} />
      <FieldLabel hint="{column} substitutes per-row">URL template</FieldLabel>
      <TextInput mono value={c.url} onChange={(v) => u({ url: v })}
        placeholder="https://api.example.com/lookup/{email}" />
      <FieldLabel>Authentication</FieldLabel>
      <Select value={c.auth || 'none'} onChange={(v) => u({ auth: v })}
        options={[
          { value: 'none', label: 'None' },
          { value: 'bearer', label: 'Bearer token' },
          { value: 'basic', label: 'Basic auth' },
          { value: 'api_key', label: 'API key header' },
        ]} />
      <FieldLabel>Rate limit (req/sec)</FieldLabel>
      <TextInput mono type="number" value={c.rate ?? 10} onChange={(v) => u({ rate: Number(v) })} />
      <PassthroughNote what="API lookup" />
    </div>
  );
}
